import React from "react";

const OnboardingHomeFake = () => {
  <>
    <div className="onboarding-home-fake">
      <div className="skeleton onboarding-home-fake--title" />
      <div className="skeleton onboarding-home-fake--btn" />
      <div className="skeleton onboarding-home-fake--conditions" />
    </div>
    <style jsx>{`
      .onboarding-home-fake {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        width: 100%;
        &--title {
          height: 16px;
          width: 90%;
        }
        &--btn {
          height: 25px;
          width: 25%;
        }
        &--conditions {
          margin-top: 1rem;
          height: 94px;
          width: 90%;
        }
      }
      @media screen and (min-width: 1024px) {
        .onboarding-home-fake {
          width: 60%;
        }
      }
    `}</style>
  </>;
};

export default OnboardingHomeFake;
